import { fetchReceptionBranches, fetchReceptionCourses } from '../../reception/apiClient';

import { authFetch } from '../../utils/authFetch';

interface UnreadCountPayload {
  unread_count?: number;
}

export async function fetchReceptionBranchesQuery(): Promise<string[]> {
  return fetchReceptionBranches();
}

export async function fetchReceptionCoursesQuery(): Promise<string[]> {
  return fetchReceptionCourses();
}

export async function fetchDailyReportsUnreadCount(): Promise<number> {
  const response = await authFetch('/reception/api/daily-reports/unread-count');
  if (!response.ok) {
    throw new Error('Failed to load unread count');
  }
  const data = (await response.json()) as UnreadCountPayload;
  return data.unread_count ?? 0;
}
